import classNames from 'classnames';
import React, { FC } from 'react';

import { State } from '../../../models';

interface Props {
  number: number;
  state: State;
}

const Badge: FC<Props> = ({ number, state }) => {
  const classes = classNames('badge', { overtime: state === State.OVERTIME, warning: state === State.WARNING });
  return <span className={classes}>{number}</span>;
};

export default Badge;
